/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import Grid from '@mui/material/Grid';
import { blockWritingCurrencyMoreThanOneBilliard } from '../../../../../../common/helpers/block-writing-keys-helper';
import NestInput from '../../../../../../components/FormItems/NestInput/NestInput';
import {
	gridFullWidth,
	gridHalfWidth,
} from '../../../../../../theme/grid/GridConstants';
import { Control, UseFormReturn } from 'react-hook-form';
import React from 'react';
import Typography from '@mui/material/Typography';
import ClientWealthAddDeleteButtons from '../ClientWealthAddDeleteButtons/ClientWealthAddDeleteButtons';
import {
	ClientWealthAppend,
	ClientWealthRemove,
	IClientWealthFormErrors,
	IClientWealthVehicle,
} from '../../../PersonalDataModels';
import { TypeOfProperty, vehicleInitObj } from '../ClientWealthFormConstants';
import { polishWordsAndDashValidator } from '../../../../../../common/validators/polishWordsValidator';
import { amountDynamicMask, simpleDigitsMask } from 'src/common/helpers/mask-helper';

interface ClientWealthVehicleProps {
	methods: UseFormReturn<Record<string, unknown>>;
	index: number;
	append: ClientWealthAppend<IClientWealthVehicle>;
	remove: ClientWealthRemove<IClientWealthVehicle>;
}

const ClientWealthVehicle = (props: ClientWealthVehicleProps): JSX.Element => {
	const watchClientWealth: IClientWealthVehicle[] = props.methods.watch(
		`clientWealth[${props.index}].name`
	);

	const clientWealthErrors = (
		props.methods.formState.errors.clientWealth as unknown as
			| IClientWealthFormErrors[]
			| undefined
	)?.[props.index]?.name;

	return (
		<>
			<Typography variant='h5' sx={{ width: '100%', marginBottom: '24px' }}>
				Samochód
			</Typography>
			{watchClientWealth.map(
				(item: IClientWealthVehicle, index: number): JSX.Element => {
					return (
						<div style={{ width: '100%', marginBottom: '24px' }} key={item.id}>
							<Grid container rowSpacing={4} columnSpacing={9}>
								<Grid item xs={gridFullWidth} md={gridHalfWidth}>
									<NestInput
										label='Marka'
										control={props.methods.control as unknown as Control}
										name={`clientWealth[${props.index}].name[${index}].brand`}
										errors={clientWealthErrors?.[index]?.brand as {type: string; message: string}}
										rules={{
											required: 'Pole wymagane',
											pattern: {
												value: polishWordsAndDashValidator,
												message: 'Niepoprawna wartość',
											},
										}}
									/>
								</Grid>
								<Grid item xs={gridFullWidth} md={gridHalfWidth}>
									<NestInput
										label='Rok produkcji'
										control={props.methods.control as unknown as Control}
										name={`clientWealth[${props.index}].name[${index}].yearOfProduction`}
										errors={clientWealthErrors?.[index]?.yearOfProduction as {type: string; message: string}}
										maskFunc={simpleDigitsMask}
										mask='####'
										rules={{
											min: {
												value: 1886,
												message: 'Niepoprawny rok produkcji',
											},
											max: {
												value: new Date().getFullYear(),
												message: 'Niepoprawny rok produkcji',
											},
											required: 'Pole wymagane',
										}}
									/>
								</Grid>
								<Grid item xs={gridFullWidth} md={gridHalfWidth}>
									<NestInput
										label='Wartość'
										control={props.methods.control as unknown as Control}
										name={`clientWealth[${props.index}].name[${index}].worth`}
										errors={clientWealthErrors?.[index]?.worth as {type: string; message: string}}
										rules={{
											required: 'Pole wymagane',
											min: {value: 1, message: 'Wartość powinna być większa niż 0'}
										}}
										maskFunc={amountDynamicMask}
										mask=''
										blockWritingSomeValueFunc={blockWritingCurrencyMoreThanOneBilliard}
									/>
								</Grid>
							</Grid>
							<ClientWealthAddDeleteButtons
								append={(): void =>
									props.append(
										`clientWealth[${props.index}].name`,
										vehicleInitObj,
										watchClientWealth
									)
								}
								remove={(): void =>
									props.remove(
										`clientWealth[${props.index}].name`,
										item.id,
										TypeOfProperty.Vehicle,
										watchClientWealth
									)
								}
							/>
						</div>
					);
				}
			)}
		</>
	);
};

export default ClientWealthVehicle;
